<template>
  <div class="content touchpad" @click="goTo(newsletter.orden)">
    <div
      :class="[
        'folder-image',
        { noBorderRadius: newsletter.logo == undefined },
      ]"
    >
      <div
        :class="[
          'img-avatar',
          { noBorderRadius: newsletter.logo == undefined },
        ]"
      >
        <img
          :class="[{ noBorderRadius: true }]"
          :src="getImagen(newsletter)"
          alt="Avatar"
          class="image"
        />
        <div class="middle">
          <div class="text"><font-awesome-icon icon="search" />Abrir</div>
        </div>
      </div>
    </div>
    <div class="folder-info">
      <h3 class="title-folder">{{ newsletter.nombre }}</h3>
      <!-- <p class="folder-name">{{ item.nombre }}</p>-->
    </div>
  </div>
</template>
<script>
export default {
  props: ["newsletter"],

  data() {
    return {};
  },
  methods: {
    getImagen(item) {
      var img =this.$store.state.defaultFolder;
      return img;
    },
    goTo(key) {
        console.log("aqui");
        this.$router.push({name:'newsletter.nombre',params:{id:key}});  
    },
  },
};
</script>
<style scoped>
.touchpad {
  cursor: pointer;
}

.img-avatar {
  height: 100%;
}

.folder .folder-image {
  border: none;
}

.folder-image .img-avatar {
  position: relative;
}

.folder-image .image {
  opacity: 1;
  display: block;
  width: 100%;
  height: 100%;
  transition: 0.5s ease;
  backface-visibility: hidden;
  border-radius: 100%;
}

.noBorder {
  border: none;
}
.noBorderRadius {
  border-radius: 0%;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.folder-image :hover .image {
  opacity: 0.2;
}

.folder-image :hover .middle {
  opacity: 1;
}

.text {
  width: 100%;
  padding: 10px;
  color: #062633;
  font-size: 16px;
}
</style>